// SapHistoricModalWrapper.tsx
import { useState, useCallback, useEffect, FC } from 'react'

import ActionSapHistoric from './Actions/Action/ActionSapHistoric'
interface SapHistoricModalWrapperProps {
  orderCode: string
  onOrderCreated?: (code: string) => void
  onModalClosed?: () => void
  successMessage?: string
}

const SapHistoricModalWrapper: FC<SapHistoricModalWrapperProps> = ({
  orderCode,
  onModalClosed,
  successMessage
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalCode, setModalCode] = useState('')

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleOpenModal = useCallback(
    (code: string) => {
      setModalCode(code)
      setIsModalOpen(true)
    },
    [setIsModalOpen]
  ) // Add setIsModalOpen to the dependency array

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false)
    setModalCode('') // Clear the modal code when closing
    if (onModalClosed) {
      onModalClosed() // Notify the parent that the modal has closed
    }
  }, [onModalClosed])

  useEffect(() => {
    if (orderCode) {
      handleOpenModal(orderCode)
    } else {
      setIsModalOpen(false) // Close the modal if orderCode becomes empty
      setModalCode('')
    }
  }, [orderCode, handleOpenModal])

  return (
    <>
      {/* Optional: Button to manually trigger the modal */}
      {/* <Button onClick={handleCreateOrder}>Criar Pedido e Mostrar Histórico</Button> */}

      <ActionSapHistoric
        code={modalCode}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        triggerModal={handleOpenModal}
        successMessage={successMessage}
      />
    </>
  )
}

export default SapHistoricModalWrapper
